module.exports = __webpack_public_path__ + "static/media/loginBg.c0e33896.png";